import { Avatar, Typography } from "@mui/material"
import { FC } from "react"

interface InitialsAvatarProps {
    initials: string;
}

//TODO: Figure out how to make the color choice "flexible"
export const InitialsAvatar: FC<InitialsAvatarProps> = ({ initials }) => {
  return (
    <Avatar className="border border-slate-200 bg-slate-100 p-8">
        <Typography className="text-slate-600 text-2xl font-semibold">{initials}</Typography>
    </Avatar>
  )
}
